"use client";

import { useState, useEffect } from "react";

export default function ModalRenewal() {
	const [isOpen, setIsOpen] = useState(false);

	useEffect(() => {
		const hasSeenModal = localStorage.getItem("hasSeenRenewalModal");
		if (!hasSeenModal) {
			setIsOpen(true);
		}
	}, []);

	const handleClose = () => {
		setIsOpen(false);
		localStorage.setItem("hasSeenRenewalModal", "true");
	};

	if (!isOpen) return null;

	return (
		<div className="fixed inset-0 z-50 flex items-center justify-center p-4">
			<div
				className="fixed inset-0 bg-black/50 backdrop-blur-sm"
				// onClick={handleClose}
			/>
			<div className="relative z-50 w-full max-w-4xl max-h-[90vh] overflow-y-auto rounded-2xl bg-base-100 p-4 sm:p-8 shadow-2xl">
				{/* <button
					onClick={handleClose}
					className="absolute right-2 top-2 sm:right-4 sm:top-4 text-base-content/70 hover:text-base-content"
				>
					<svg
						className="h-6 w-6"
						fill="none"
						viewBox="0 0 24 24"
						stroke="currentColor"
					>
						<path
							strokeLinecap="round"
							strokeLinejoin="round"
							strokeWidth={2}
							d="M6 18L18 6M6 6l12 12"
						/>
					</svg>
				</button> */}

				<div className="flex flex-col items-center space-y-4 sm:space-y-6">
					<div className="flex h-14 w-14 sm:h-16 sm:w-16 items-center justify-center rounded-full bg-primary/10">
						<svg
							className="h-7 w-7 sm:h-8 sm:w-8 text-primary"
							fill="none"
							viewBox="0 0 24 24"
							stroke="currentColor"
						>
							<path
								strokeLinecap="round"
								strokeLinejoin="round"
								strokeWidth={2}
								d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"
							/>
						</svg>
					</div>

					<h2 className="text-center text-2xl sm:text-3xl font-bold text-base-content">
						🎉 <span className="text-primary">Swendo Shop v2</span> is Here! 🎉
					</h2>

					<div className="space-y-3 sm:space-y-4 text-center text-base-content/80 text-sm sm:text-base">
						<p className="font-bold text-lg sm:text-xl tracking-wide">
							Dear{" "}
							<span className="text-primary font-extrabold bg-gradient-to-r from-primary/20 to-secondary/20 px-2 py-0.5 rounded-lg">
								Valued Customers
							</span>
							,
						</p>
						<p>
							We're thrilled to share some{" "}
							<span className="font-semibold">exciting news</span> — the beta
							phase of Swendo Shop is now complete, and we've officially
							launched our{" "}
							<span className="font-semibold">brand-new platform</span>!
						</p>
						<p>
							Swendo Shop has been{" "}
							<span className="font-semibold">completely redesigned</span> to
							offer you a smoother, faster, and more enjoyable shopping
							experience. Our team has worked tirelessly to create a platform
							that exceeds your expectations.
						</p>
						<h3 className="text-xl font-bold text-primary mb-4">
							✨ What's New:
						</h3>
						<ul className="list-inside list-disc space-y-1 sm:space-y-2 text-left">
							<li>
								A <span className="font-bold">fresh, modern interface</span> for
								easier navigation
							</li>
							<li>
								A{" "}
								<span className="font-bold">more powerful account system</span>{" "}
								for better control and security
							</li>
							<li>
								A <span className="font-bold">broadened product selection</span>{" "}
								with exciting new items
							</li>
							<li>
								A{" "}
								<span className="font-bold">
									streamlined shopping experience
								</span>{" "}
								from start to finish
							</li>
							<li>
								A <span className="font-bold">faster checkout</span> to save you
								time
							</li>
							<li>
								An{" "}
								<span className="font-bold">optimized mobile experience</span>{" "}
								for shopping on the go
							</li>
							<li>
								<span className="font-bold">Enhanced customer support</span> for
								your convenience
							</li>
							<li>
								<span className="font-bold">Personalized recommendations</span>{" "}
								based on your preferences
							</li>
						</ul>
						<p>
							We're committed to continuously improving and bringing you the{" "}
							<span className="font-semibold">best service possible</span>. Your
							support and feedback have been essential in shaping the future of
							Swendo Shop — thank you!
						</p>

						<div className="mt-4 sm:mt-6 rounded-lg bg-base-200 p-3 sm:p-4 text-left border-l-4 border-primary">
							<h3 className="mb-2 font-semibold text-base-content">
								Important Information for Beta Users:
							</h3>
							<p className="mb-2">
								If you were a{" "}
								<span className="font-bold">Swendo Shop Beta user</span>, please
								note that your previous account has been deleted as part of our
								system upgrade.
							</p>
							<ul className="list-inside list-disc space-y-1 pl-4">
								<li>
									You can still{" "}
									<span className="font-bold">
										access and use any active subscriptions
									</span>{" "}
									from your old account.
								</li>
								<li>
									However,{" "}
									<span className="font-bold">
										purchasing old products or renewing previous subscriptions
										is no longer possible
									</span>
									.
								</li>
							</ul>
							<p className="mt-2">
								If you wish to transfer your remaining balance from your old
								account to your new one, or if you encounter any issues related
								to your previous account, please contact us at{" "}
								<a
									href="mailto:info@swendoshop.com"
									className="text-primary hover:underline font-bold"
								>
									info@swendoshop.com
								</a>
								. We're here to help!
							</p>
						</div>

						<p className="text-xs sm:text-sm italic">
							Warm regards,
							<br />
							<span className="font-bold">The Swendo Shop Team</span>
						</p>
					</div>

					<button
						onClick={handleClose}
						className="group relative inline-flex items-center justify-center gap-2 rounded-lg bg-primary px-4 sm:px-6 py-2 sm:py-3 text-sm sm:text-base font-bold text-primary-content transition-all duration-300 hover:bg-primary/90 hover:shadow-lg hover:shadow-primary/20 mt-2 sm:mt-4"
					>
						<span>Start Exploring</span>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							className="h-4 w-4 sm:h-5 sm:w-5 transition-transform duration-300 group-hover:translate-x-1"
							fill="none"
							viewBox="0 0 24 24"
							stroke="currentColor"
						>
							<path
								strokeLinecap="round"
								strokeLinejoin="round"
								strokeWidth={2}
								d="M13 7l5 5m0 0l-5 5m5-5H6"
							/>
						</svg>
					</button>
				</div>
			</div>
		</div>
	);
}
